import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wooNullIfZero',
  standalone: false,
})
export class NullIfZero implements PipeTransform {
  transform(value: any): any {
    return value === 0 ? null : value;
  }
}
